import { createRouter, createWebHistory } from "vue-router"
import HomeView from "../pages/index.vue"

const routes = [
  {
    path: "/",
    name: "home",
    component: HomeView,
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
})

router.beforeEach((to, from, next) => {
  window.history.replaceState({}, "", to.fullPath)
  next()
})

export default router
